import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import saleReducer from './saleSlice';
import serviceReducer from './serviceSlice';
import userReducer from './userSlice';
import statsReducer from './statsSlice';
import reportsReducer from './reportsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    sales: saleReducer,
    services: serviceReducer,
    users: userReducer,
    stats: statsReducer,
    reports: reportsReducer,
  },
});

export default store;
